import { InfoField } from "common/types/common/components/questionnaireTypes";

// ファイル末尾のMULTIPASS宣言のみ残す
export const MULTIPASS = {
  naraCity: "nara-city",
  osakaCity: "osaka-city",
  kyotoCity: "kyoto-city",
  hiroshimaCity: "hiroshima-city",
  fukuokaCity: "fukuoka-city",
  nagoyaCity: "nagoya-city",
  sendaiCity: "sendai-city",
  sapporoCity: "sapporo-city",
  hokutoCity: "hokuto-city",
};

// MULTIPASSの値から自治体名リストを自動生成
export const MUNICIPALITY_LIST = Object.values(MULTIPASS);
// adminを除去したいパス一覧
export const ADMIN_EXCLUDE_LIST = ["/login"];
// 定数定義ファイル

// localStrorageのキー名の定数
export const localStorageKeys: { LoginJWT: string } = {
  LoginJWT: "HCRS_JWT",
};

// システム名の定数
export const systemConst: { name: string } = {
  name: "けんしん予約システム",
};

// ドメイン
export const TEST_DOMAIN = "test-hcrs.toshimaku-kensui-hiv.jp"; // テスト環境ドメイン
export const DEMO_DOMAIN = ""; // デモ環境ドメイン
export const PROD_DOMAIN = ""; // 本番環境ドメイン

// 年（1900～今年）の配列
export const years: number[] = Array.from(
  { length: new Date().getFullYear() - 1900 + 1 },
  (_, i) => 1900 + i,
);

// 年（今年から10年後）の配列
export const years10: number[] = Array.from(
  { length: 10 },
  (_, i) => new Date().getFullYear() + i,
);

// 日付 (1日から31日まで) の配列
export const days: number[] = Array.from({ length: 31 }, (_, i) => i + 1);

// 月 (1月から12月まで) の配列
export const months: number[] = Array.from({ length: 12 }, (_, i) => i + 1);

// ページネーションの１ページあたりの表示件数
export const rowsPerPage: number = 5;

/**
 * 住民側ストレージ
 */
export const residentStorageKeys: {
  governmentCodeMst: string;
  fontSize: string;
  questionnaireBasicInfoAgreed: string;
} = {
  governmentCodeMst: "government_code_mst",
  fontSize: "hcrs_font_size",
  questionnaireBasicInfoAgreed: "hcrs_questionnaire_basic_info_agreed",
};

/**
 * 管理側ストレージ
 */
export const adminStorageKeys: {
  adminLocalCaseCode: string;
  adminLocalPlaceCode: string;
  adminLocalDashboardCaseCodes: string;
  loginPreferredMethod: string;
} = {
  adminLocalCaseCode: "hcrs_admin_case_code",
  adminLocalPlaceCode: "hcrs_admin_place_code",
  adminLocalDashboardCaseCodes: "hcrs_admin_dashboard_case_codes",
  loginPreferredMethod: "hcrs_login_preferred_method",
};

/**
 * けんしん状況ステータス
 * booking:1 予約中
 * complete:5 検診完了(受診済み)
 * cancel:9 予約キャンセル
 */
export const healthCheckStatus: {
  booking: number;
  complete: number;
  cancel: number;
} = {
  booking: 1,
  complete: 5,
  cancel: 9,
};

export const CLAIMS = {
  // 役割のLv
  Role_Lv: "Role_Lv",
  // Administrator
  Administrator: "administrator",
  // 自治体管理者
  Government_Admin: "government-admin",
  // 案件管理者
  Case_Admin: "case-admin",
  // コールセンタ管理者
  Call_Center_Admin: "call-center-admin",
  // コールセンタ運用者
  Call_Center_Operation: "call-center-operation",
  // 公共施設
  Public_Facility: "public-facility",
  // 医療機関
  Healthcare_Facility: "healthcare-facility",
} as const;

export type ClaimsType = (typeof CLAIMS)[keyof typeof CLAIMS];

export const USER_TYPE = {
  CALL_CENTER: "callcenter",
  PUBLIC: "public",
  MEDICAL: "medical",
} as const;

/**
 * 自治体コードマスタ（）
 * 変数名：GroupCodeName
 * DOCUMENT : "Document"
 * ENVIROMENT : "Environment"
 * MAIL : "Mail"
 * RESERVATION : "Reservation"
 * RESERVATIONN_VOTES : "ReservationVotes"
 * DASHBOARD : "DashBoard"
 */
export const GROUP_CODE_NAME = {
  DOCUMENT: "Document",
  ENVIROMENT: "Environment",
  MAIL: "Mail",
  RESERVATION: "Reservation",
  RESERVATION_VOTES: "ReservationVotes",
  DASHBOARD: "DashBoard",
} as const;
export type GroupCodeNameType =
  (typeof GROUP_CODE_NAME)[keyof typeof GROUP_CODE_NAME];

/**
 * 案件コードマスタ
 * ENVIROMENT : "Environment"
 * SCREEN: "Screen"
 * MAIL : "Mail"
 * DASHBOARD : "DashBoard"
 */
export const CASE_CODE_GROUP = {
  ENVIROMENT: "Environment",
  SCREEN: "Screen",
  MAIL: "Mail",
  DASHBOARD: "DashBoard",
} as const;
export type CaseCodeGroupType =
  (typeof CASE_CODE_GROUP)[keyof typeof CASE_CODE_GROUP];

/**
 * HTTPステータスコード一覧
 */
export const HTTP_STATUS_CODE = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

/**
 * APIレスポンスメッセージ一覧
 */
export const API_RESPONSE_MESSAGES = {
  NOT_FOUND: "リソースが見つかりません。",
  UNAUTHORIZED: "セッションが存在しません。",
  FORBIDDEN: "アクセスが拒否されました。",
  INTERNAL_SERVER_ERROR: "サーバーエラーが発生しました。",
} as const;

// 画像圧縮の定数
export const IMAGE_CONST = {
  image_compress_size_200KB: 0.2, // 画像の圧縮（200kb）
  image_compress_size_20KB: 0.02, // 画像の圧縮（20kb）
  image_compress_size_100KB: 0.1, // 画像の圧縮（100kb）
};

// キャンセル可否の定数
export const CANCELLATION_POLICY = {
  CANCEL: "0", // 予約キャンセル可
  NOT_CANCEL: "1", // 予約キャンセル不可
} as const;

//キャンセル可否の詳細の定数
export const CANCELLATION_TYPE = {
  ALWAYS_CANCEL: "0", // 常時キャンセル可能
  JUST_BEFORE: "1", // 予約直前まで
  BEFORE_DAY: "2", // 予約X日前の予約時刻まで
  BEFORE_DATETIME: "3", // 予約X日前の設定時刻まで
} as const;

// QRコードスキャンのエラー名
export const CAMERA_ERROR_NAMES = [
  "NotAllowedError",
  "NotFoundError",
  "NotReadableError",
  "OverconstrainedError",
  "NotSupportedError",
  "SecurityError",
];

// Web問診票　質問タイプ
export const QUESTION_TYPE = {
  YES_NO: 1,
  RADIO_BUTTON: 2,
  CHECKBOX: 3,
  SELECT_BOX: 4,
  STRING: 5,
  TEXT_AREA: 6,
  NUMBER: 7,
} as const;

// 詳細質問回答の最大文字数
export const QUESTION_DETAIL_SLOT_MAX_LENGTH = 100;

/**
 * Web問診票　回答制約
 * - MAX_SELECTION: 最大選択数（チェックボックスの選択数の上限）
 * - MIN_SELECTION: 最小選択数（チェックボックスの選択数の下限）
 * - EXACT_SELECTION: 正確な選択数（チェックボックスの選択数の固定数）
 * - MIN_VALUE: 最小値（数値入力の最小値）
 * - MAX_VALUE: 最大値（数値入力の最大値）
 * - ALLOW_DECIMAL: 小数点の許可（数値入力で小数点を許可するかどうかのフラグ）
 */
export const QUESTION_CONSTRAINT_VALUE = {
  MAX_SELECTION: 1,
  MIN_SELECTION: 2,
  EXACT_SELECTION: 3,
  MIN_VALUE: 4,
  MAX_VALUE: 5,
  ALLOW_DECIMAL: 6,
} as const;

// Web問診票　回答状況
export const QUESTIONNAIRE_ANSWER_STATUS = {
  UNANSWERED: -1, // 未回答（問診票が存在する場合＆回答データが存在しない場合）
  TEMPORARY_SAVED: 0, // 一時保存
  COMPLETED: 1, // 回答完了
} as const;

// Web問診票　印刷状況
export const QUESTIONNAIRE_PRINT_STATUS = {
  NOT_PRINTED: 0, // 未印刷
  PRINTED: 1, // 印刷済み
} as const;

// 住民情報フィールド定義
export const residentInfoFields: InfoField[] = [
  {
    label: "予約番号",
    registerKey: "entryId",
    fields: ["entryId"],
    presenceKey: "entryIdPresence",
    requiredKey: "entryIdRequired",
    disabled: true,
  },
  {
    label: "氏名",
    registerKey: "fullname",
    fields: ["fullname"],
    presenceKey: "fullnamePresence",
    requiredKey: "fullnameRequired",
    disabled: true,
  },
  {
    label: "カナ氏名", // 氏名（カナ）
    registerKey: "furigana",
    fields: ["furigana"],
    presenceKey: "furiganaPresence",
    requiredKey: "furiganaRequired",
    disabled: true,
  },
  {
    label: "郵便番号",
    registerKey: "postCode",
    fields: ["postCode"],
    presenceKey: "postCodePresence",
    requiredKey: "postCodeRequired",
    disabled: true,
  },
  {
    label: "住所",
    registerKey: "address",
    fields: ["address"],
    presenceKey: "addressPresence",
    requiredKey: "addressRequired",
    fullWidth: true,
    disabled: true,
  },
  {
    label: "年齢",
    registerKey: "age",
    fields: ["age"],
    presenceKey: "agePresence",
    requiredKey: "ageRequired",
    inputType: "number",
    disabled: true,
  },
  {
    label: "生年月日",
    registerKey: "dateOfBirthWestern",
    fields: ["birthYear", "birthMonth", "birthDay"],
    presenceKey: "dateOfBirthPresence",
    requiredKey: "dateOfBirthRequired",
    inputType: "birthdate",
    fullWidth: true,
    disabled: true,
  },
  {
    label: "性別",
    registerKey: "gender",
    fields: ["gender"],
    presenceKey: "genderPresence",
    requiredKey: "genderRequired",
    inputType: "gender",
    disabled: true,
  },
  {
    label: "電話番号",
    registerKey: "phoneNumber",
    fields: ["phoneNumber"],
    presenceKey: "phoneNumberPresence",
    requiredKey: "phoneNumberRequired",
    placeholder: "ハイフンなしで入力してください",
    inputType: "tel",
    disabled: false,
  },
  {
    label: "メールアドレス",
    registerKey: "email",
    fields: ["email"],
    presenceKey: "emailPresence",
    requiredKey: "emailRequired",
    inputType: "email",
    disabled: false,
  },
  {
    label: "保護者氏名",
    registerKey: "guardianName",
    fields: ["guardianName"],
    presenceKey: "guardianNamePresence",
    requiredKey: "guardianNameRequired",
    disabled: false,
  },
  {
    label: "整理番号",
    registerKey: "referenceNo",
    fields: ["referenceNo"],
    presenceKey: "referenceNoPresence",
    requiredKey: "referenceNoRequired",
    disabled: true,
  },
];

//----------------------------------------------------------------

// その他情報フィールド定義
export const othersInfoFields: InfoField[] = [
  {
    label: "本人の署名（もしくは保護者の署名）",
    registerKey: "personSignature",
    fields: ["personSignature"],
    presenceKey: "personSignaturePresence",
    requiredKey: "personSignatureRequired",
    showInQuestionnaireResidentInfoForm: false,
    placeholder: "",
    disabled: false,
  },
  {
    label: "医師署名",
    registerKey: "doctorSignature",
    fields: ["doctorSignature"],
    presenceKey: "doctorSignaturePresence",
    requiredKey: "doctorSignatureRequired",
    showInQuestionnaireResidentInfoForm: false,
    placeholder: "",
    disabled: false,
  },
  {
    label: "実施場所",
    registerKey: "healthCheckPlaceName",
    fields: ["healthCheckPlaceName"],
    presenceKey: "healthCheckPlacePresence",
    requiredKey: "healthCheckPlaceRequired",
    placeholder: "",
    disabled: true,
  },
  {
    label: "医師名",
    registerKey: "doctorName",
    fields: ["doctorName"],
    presenceKey: "doctorNamePresence",
    requiredKey: "doctorNameRequired",
    placeholder: "",
    disabled: false,
  },
  {
    label: "接種日時",
    registerKey: "vaccinationDateTime",
    fields: ["vaccinationDateTime"],
    presenceKey: "vaccinationDateTimePresence",
    requiredKey: "vaccinationDateTimeRequired",
    placeholder: "",
    inputType: "date",
    disabled: false,
  },
];

// 画面遷移の際の確認メッセージ
export const BLOCK_MESSAGE = "入力中のデータが失われますが、よろしいですか？";
